import { StatusVariant } from '../ui';
import { TakeoverRequestStatus } from './types';

export const STATUS_VARIANT: Record<TakeoverRequestStatus, StatusVariant> = {
  new: 'pending',
  in_review: 'draft',
  approved: 'approved',
  booked: 'live',
  declined: 'paused',
  expired: 'flagged',
};

export const fmtUsd = (n: number): string =>
  n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export const fmtDate = (iso?: string): string => {
  if (!iso) return '—';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const fmtDateTime = (iso?: string): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
};

export const fmtWindow = (w: { startDate: string; endDate: string }): string =>
  `${fmtDate(w.startDate)} → ${fmtDate(w.endDate)}`;
